module.exports = __webpack_public_path__ + "img/new_booking.2376ef14.jpg";